import { createBrowserRouter } from 'react-router-dom';
import App from './App';
import ClusterList from './pages/Cluster/ClusterList';
import Login from './pages/Login';
import BasicLayout from './pages/Layout/BasicLayout';
import ClusterDashboard from './pages/Cluster/Dashboard';
import BookkeeperDashboard from './pages/Cluster/Bookkeeper/Dashboard';
import ZookeeperDashboard from './pages/Cluster/Zookeeper/Dashboard';
import BrokerDashboard from './pages/Cluster/Broker/Dashboard';
import MenuLayout from './pages/Layout/MenuLayout';
import Message from './pages/Cluster/Utils/Message';
import Roles from './pages/Cluster/Permissions/Roles';
import Grant from './pages/Cluster/Permissions/Grant';
import TenantList from './pages/Cluster/Tenant/List';
import ZookeeperList from './pages/Cluster/Zookeeper/List';
import BookieList from './pages/Cluster/Bookkeeper/BookieList';
import AutoRecover from './pages/Cluster/Bookkeeper/AutoRecover';
import BrokerList from './pages/Cluster/Broker/BrokerList';
import NamespaceList from './pages/Cluster/Namespace/NameSpaceList';
import TopicList from './pages/Cluster/Topic/TopicList';
import ScriptList from './pages/Maintenance/Template/Script';
import ComponentList from './pages/Maintenance/Template/Component/List';
import FlowList from './pages/Maintenance/Template/Flow/List';
import ScriptDetail from './pages/Maintenance/Template/Script/Detail';
import ComponentDetail from './pages/Maintenance/Template/Component/Detail';
import FlowDetail from './pages/Maintenance/Template/Flow/Detail';
import EvnList from './pages/Maintenance/Resource/Env/List';
import EnvManage from './pages/Maintenance/Resource/Env/Manage';
import ResourceCluster from './pages/Maintenance/Resource/Cluster';
import ClusterDetail from './pages/Maintenance/Resource/Cluster/Detail';
import ResourceHost from './pages/Maintenance/Resource/Host/HostList';
import WebSSH from './pages/Maintenance/Resource/Host/WebSSH';
import K8sList from './pages/Maintenance/Resource/K8s/List';
import ExecutiveScript from './pages/Maintenance/Executive/Script';
import ExecutiveComponent from './pages/Maintenance/Executive/Component';
import ExecutiveFlow from './pages/Maintenance/Executive/Flow';
import ExecutiveRecord from './pages/Maintenance/Executive/Record';
import RecordDetail from './pages/Maintenance/Executive/Record/Detail';
import FlowExecuteDetail from './pages/Maintenance/Executive/Flow/Detail';
import ExecuteComponentDetail from './pages/Maintenance/Executive/Component/Detail';
import Dictionary from './pages/Platform/Dictionary';
import Inspect from './pages/Platform/Inspect';
import Token from './pages/Cluster/Utils/Token';
import Role from './pages/Platform/Role';
import User from './pages/Platform/User';
import Menu from './pages/Platform/Menu';
import Logs from './pages/Platform/Logs';
import License from './pages/Platform/License';
import PermWrapper from './components/PermWrapper';
import FunctionList from './pages/Cluster/Function/FunctionList';
import SourceList from './pages/Cluster/Function/SourceList';
import SinkList from './pages/Cluster/Function/SinkList';
import ProxyDetected from './pages/Maintenance/Inspect/ProxyDetected';
import Variables from './pages/Maintenance/Template/Variables';
import ClusterVariables from './pages/Maintenance/Executive/ClusterVariables';
import ErrorPage502 from './pages/ErrorPage/502';
import CodeSamples from './pages/Dev/CodeSamples';
import MessageList from './pages/Pro/MessageTrace/MessageList';
import MessageSendReceive from './pages/Dev/MessageSendReceive';
import KOPClusterList from './pages/KOPCluster/ClusterList';
import KOPClusterDashboard from './pages/KOPCluster/Dashboard';
import KOPTopicList from './pages/KOPCluster/Topic/TopicList';
import KOPConsumerGroupList from './pages/KOPCluster/ConsumerGroup/ConsumerGroupList';
import KOPNamespaceList from './pages/KOPCluster/Namespace/NameSpaceList';
import KOPUsers from './pages/KOPCluster/Permissions/Users';
import KOPGrant from './pages/KOPCluster/Permissions/Grant';
import KOPBrokerDashboard from './pages/KOPCluster/Broker/Dashboard';
import KOPBrokerList from './pages/KOPCluster/Broker/BrokerList';
import KOPBookkeeperDashboard from './pages/KOPCluster/Bookkeeper/Dashboard';
import KOPBookieList from './pages/KOPCluster/Bookkeeper/BookieList';
import KOPAutoRecover from './pages/KOPCluster/Bookkeeper/AutoRecover';
import KOPZookeeperDashboard from './pages/KOPCluster/Zookeeper/Dashboard';
import KOPZookeeperList from './pages/KOPCluster/Zookeeper/List';
import KOPTenantList from './pages/KOPCluster/Tenant/List';
import Organize from './pages/Platform/Organize';
import PackageManage from './pages/Cluster/Function/PackageManage';
import ServiceDiscovery from './pages/Maintenance/Recovery/ServiceDiscovery';
import Config from './pages/Platform/Config';
import ThirdPartyOauth from './pages/ThirdPartyOauth';
import ClusterListPermWrapper from './pages/Cluster/ClusterList/ClusterListPermWrapper';

export const routes = createBrowserRouter([
  {
    path: '*',
    element: <App />,
    children: [
      {
        path: 'login',
        element: <Login />,
      },
      {
        path: 'superadmin-hlogin',
        element: <Login />,
      },
      {
        path: 'third-party/oauth',
        element: <ThirdPartyOauth />,
      },
      {
        path: '*',
        element: <BasicLayout />,
        children: [
          {
            path: 'cluster',
            children: [
              {
                index: true,
                element: (
                  // 特殊权限需求
                  <ClusterListPermWrapper>
                    <ClusterList />
                  </ClusterListPermWrapper>
                ),
              },
              {
                path: '*',
                element: <MenuLayout />,
                children: [
                  {
                    path: 'dashboard',
                    element: <ClusterDashboard />,
                  },
                  {
                    path: 'broker/dashboard',
                    element: <BrokerDashboard />,
                  },
                  {
                    path: 'broker/list',
                    element: <BrokerList />,
                  },
                  {
                    path: 'bookkeeper/dashboard',
                    element: <BookkeeperDashboard />,
                  },
                  {
                    path: 'bookie/list',
                    element: <BookieList />,
                  },
                  {
                    path: 'bookkeeper/auto-recover',
                    element: <AutoRecover />,
                  },
                  {
                    path: 'zookeeper/dashboard',
                    element: <ZookeeperDashboard />,
                  },
                  {
                    path: 'zookeeper/list',
                    element: <ZookeeperList />,
                  },
                  {
                    path: 'tenant/list',
                    element: <TenantList />,
                  },
                  {
                    path: 'namespace/list',
                    element: <NamespaceList />,
                  },
                  {
                    path: 'topic/list',
                    element: <TopicList />,
                  },
                  {
                    path: 'function-packageManage/list',
                    element: <PackageManage />,
                  },
                  {
                    path: 'function/list',
                    element: <FunctionList />,
                  },
                  {
                    path: 'function-source/list',
                    element: <SourceList />,
                  },
                  {
                    path: 'function-sink/list',
                    element: <SinkList />,
                  },
                  {
                    path: 'permissions/roles',
                    element: <Roles />,
                  },
                  {
                    path: 'permissions/grant',
                    element: <Grant />,
                  },
                  {
                    path: 'utils/message',
                    element: <Message />,
                  },
                  {
                    path: 'utils/token',
                    element: <Token />,
                  },
                ],
              },
            ],
          },
          {
            path: 'kop-cluster',
            children: [
              {
                index: true,
                // 特殊处理一下看板未授权时候的初始页面
                element: (
                  <PermWrapper resource='kop:cluster:cluster_list'>
                    <KOPClusterList />
                  </PermWrapper>
                ),
              },
              {
                path: '*',
                element: <MenuLayout />,
                children: [
                  {
                    path: 'dashboard',
                    element: <KOPClusterDashboard />,
                  },
                  {
                    path: 'topic/list',
                    element: <KOPTopicList />,
                  },
                  {
                    path: 'broker/dashboard',
                    element: <KOPBrokerDashboard />,
                  },
                  {
                    path: 'broker/list',
                    element: <KOPBrokerList />,
                  },
                  {
                    path: 'bookkeeper/dashboard',
                    element: <KOPBookkeeperDashboard />,
                  },
                  {
                    path: 'bookie/list',
                    element: <KOPBookieList />,
                  },
                  {
                    path: 'bookkeeper/auto-recover',
                    element: <KOPAutoRecover />,
                  },
                  {
                    path: 'zookeeper/dashboard',
                    element: <KOPZookeeperDashboard />,
                  },
                  {
                    path: 'zookeeper/list',
                    element: <KOPZookeeperList />,
                  },
                  {
                    path: 'tenant/list',
                    element: <KOPTenantList />,
                  },
                  {
                    path: 'namespace/list',
                    element: <KOPNamespaceList />,
                  },
                  {
                    path: 'consumer-group/list',
                    element: <KOPConsumerGroupList />,
                  },
                  {
                    path: 'permissions/users',
                    element: <KOPUsers />,
                  },
                  {
                    path: 'permissions/grant',
                    element: <KOPGrant />,
                  },
                ],
              },
            ],
          },

          {
            path: 'maintenance',
            element: <MenuLayout />,
            children: [
              {
                path: 'resource',
                children: [
                  {
                    path: 'env',
                    element: <EvnList />,
                  },
                  {
                    path: 'env/manage/:productLibId',
                    element: <EnvManage />,
                  },
                  {
                    path: 'cluster',
                    element: <ResourceCluster />,
                  },
                  {
                    path: 'cluster/detail/:id',
                    element: <ClusterDetail />,
                  },
                  {
                    path: 'host',
                    element: <ResourceHost />,
                  },
                  {
                    path: 'host/webssh',
                    element: <WebSSH />,
                  },
                  {
                    path: 'k8s',
                    element: <K8sList />,
                  },
                ],
              },
              {
                path: 'template',
                children: [
                  {
                    path: 'variables',
                    element: <Variables />,
                  },
                  {
                    path: 'script',
                    element: <ScriptList />,
                  },
                  {
                    path: 'script/detail/:id?',
                    element: <ScriptDetail />,
                  },
                  {
                    path: 'component',
                    element: <ComponentList />,
                  },
                  {
                    path: 'component/detail/:id?',
                    element: <ComponentDetail />,
                  },
                  {
                    path: 'flow',
                    element: <FlowList />,
                  },
                  {
                    path: 'flow/detail',
                    element: <FlowDetail />,
                  },
                ],
              },
              {
                path: 'executive',
                children: [
                  {
                    path: 'script',
                    element: <ExecutiveScript />,
                  },
                  {
                    path: 'component',
                    element: <ExecutiveComponent />,
                  },
                  {
                    path: 'component/detail',
                    element: <ExecuteComponentDetail />,
                  },
                  {
                    path: 'flow',
                    element: <ExecutiveFlow />,
                  },
                  {
                    path: 'flow/detail',
                    element: <FlowExecuteDetail />,
                  },
                  {
                    path: 'record',
                    element: <ExecutiveRecord />,
                  },
                  {
                    path: 'record/detail',
                    element: <RecordDetail />,
                  },
                  { path: 'variables', element: <ClusterVariables /> },
                ],
              },
              {
                path: 'inspect',
                children: [
                  {
                    path: 'proxy-detected',
                    element: <ProxyDetected />,
                  },
                ],
              },
              {
                path: 'recovery',
                children: [
                  {
                    path: 'service-discovery',
                    element: <ServiceDiscovery />,
                  },
                ],
              },
            ],
          },
          {
            path: 'platform',
            element: <MenuLayout />,
            children: [
              {
                path: 'config',
                element: <Config />,
              },
              {
                path: 'organize',
                element: <Organize />,
              },
              {
                path: 'dictionary',
                element: <Dictionary />,
              },
              {
                path: 'inspect',
                element: <Inspect />,
              },
              {
                path: 'role',
                element: <Role />,
              },
              {
                path: 'user',
                element: <User />,
              },
              {
                path: 'menu',
                element: <Menu />,
              },
              {
                path: 'logs',
                element: <Logs />,
              },
              {
                path: 'license',
                element: <License />,
              },
            ],
          },
          {
            path: 'dev',
            element: <MenuLayout />,
            children: [
              {
                path: 'code-samples',
                element: <CodeSamples />,
              },
              {
                path: 'message-send-receive',
                element: <MessageSendReceive />,
              },
            ],
          },
          {
            path: 'pro',
            element: <MenuLayout />,
            children: [
              {
                path: 'message-trace',
                element: <MessageList />,
              },
            ],
          },
        ],
      },
      {
        path: 'error-502',
        element: <ErrorPage502 />,
      },
    ],
  },
]);
